module.exports = __webpack_public_path__ + "img/profil_lapper_paula.e73513e2.png";